import useSWR from 'swr';

import { Product } from '@bpm-web-app/api-client';

export function useGetProduct(sku?: string, enabled = true) {
    const { data, error } = useSWR(
        [
            `get-product-${sku}`,
            {
                persist: false,
                sku,
            },
        ],
        () => (sku ? Product.getProduct(sku) : null),
        { isPaused: () => !enabled || !sku }
    );
    return {
        data: data?.data,
        isLoading: !error && !data && Boolean(sku),
        error,
    };
}
